import React, { useState, useEffect, useRef } from "react";
import { Tag, Button, Input, Card, message, Skeleton, Select, Modal, Col, Drawer, Spin } from "antd";
import {
  PhoneOutlined,
  EnvironmentOutlined,
  StarFilled,
  EditOutlined,
  CloseOutlined,
  CloseSquareFilled,
  CustomerServiceOutlined,
  ArrowLeftOutlined,
  ClockCircleOutlined,
  SearchOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import CustomerSearch from "../../../assets/images/search.png";
import CustomerIcon from "../../../assets/images/userId.svg";
import View from "../../../assets/images/view.svg";
import AddUser from "../../../assets/images/userAdd.svg";
import DefaultProductImage from "../../../assets/images/no-image.svg";
import DeleteProduct from "../../../assets/images/delete1.svg";
import BackIcon from "../../../assets/images/backIcon.svg";
import SearchIcon from "../../../assets/images/searchIcon.svg";
import POSLogo from "../../../assets/images/NewLogoCW.svg";
import LockIcon from "../../../assets/images/lock-icon.svg";
import userIcon from "../../../assets/images/userId.svg";
import Online from "../../../assets/images/green.svg";
import Offline from "../../../assets/images/red.svg";
import cardType from "../../../assets/images/cardType.svg";
import UPI from "../../../assets/images/upiIcon.svg";
import moment from "moment";
import Scrollbars from "react-custom-scrollbars";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import { posOrderProcessor1 } from "../../../services";
import { getRetailStores } from "../../../services/generic";
import db from "../../../database";

const RestaurantCallCenter = (props) => {
  const {
    tillData,
    selectCustomer,
    setDisplayCustomerSearch,
    setCloseCustomerFlag,
    setProductSearchInput,
    closeCustomerSearch,
    showEditOldCustomerFields,
    showAddNewCustomerFields,
    removeCutomer,
    setEditFlag,
    customerId,
    setCustomerSearchResults,
    setCustomerSearchInput,
    handleCustomerSearch,
    setKeyboardInputFields,
    keyboardInputFields,
    inputName,
    keyboard,
    setLoading,
    productSearchInput,
    setProductsData,
    saleTypeProducts,
    setSaleTypeProducts,
    productsData,
    handleAddOnModal,
    restaurantProductCategory,
    pickProduct,
    deleteProduct,
    callCenterVisible,
    setCallCenterVisible,
    callCenterModal,
    setCallCenterModal,
    increaseProductQty,
    decreaseProductQty,
    setCart,
    setIsCallCenterFlow,
    isCallCenterFlow,
    showCallCenterPage,
    setShowCallCenterPage,
    holdQueue,
    setHoldQueue,
    searchOrderHistory,
    setShowProducts,
    orderHistoryDetails,
    setOrderHistoryDetails,
    loading,
    showPayments,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    processOrder,
    getFilteredPaymentMethods
  } = props;
  const [selectedAddress, setSelectedAddress] = useState("Home");
  const [selectedMode, setSelectedMode] = useState("Delivery");
  const [isCustomerSearchVisible, setIsCustomerSearchVisible] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [selectCategoryList, setSelectCategoryList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [productCategoriesList, setProductCategoriesList] = useState([]);
  const [displayedProducts, setDisplayedProducts] = useState([]);
  const [hasMoreProducts, setHasMoreProducts] = useState(true);
  const [orderHistory, setOrderHistory] = useState([]);
  const [showOrderHistoryModal, setShowOrderHistoryModal] = useState(false);
  const [showPriceDetails, setShowPriceDetails] = useState(false);
  const [retailStores, setRetailStores] = useState([]);
  const defaultCustomer = tillData.tillAccess.csBunit.b2cCustomer;
  const [ahtSeconds, setAhtSeconds] = useState(0);
  const timerRef = useRef(null);
  const hasLoadedOrderHistory = useRef(false);
  const storesLoaded = useRef(false);
  const [holdRecords, setHoldRecords] = useState([]);
  const [isOnHold, setIsOnHold] = useState(false);
  const [showCallCenter, setShowCallCenter] = useState(false);
  const tillDocumentSequence = parseFloat(localStorage.getItem("documentSequence"));
  const userData = JSON.parse(localStorage.getItem("userData"));
  const tillValue = JSON.parse(localStorage.getItem("tillValue"));
  const [orderHistoryLoading, setOrderHistoryLoading] = useState(false);
  const [isPaymentSelected, setIsPaymentSelected] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null); // ← NEW
  const [storeModalVisible, setStoreModalVisible] = useState(false);
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const showImage = posConfig?.showImage === "Y";
  const pricePrecision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision;
  const ITEMS_PER_LOAD = 50;
  const scrollContainerRef = useRef(null);
  const debounceTimeout = useRef(null);
  const orderState = useRef(0);           // ← Click counter
  const activeOrderProcess = useRef(false); // ← Processing lock
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const history = useHistory();
  const modes = ["Delivery", "Pickup", "Dine-in"];
  const onChangeInput = (event) => {
    const inputVal = event.target.value;

    setKeyboardInputFields({
      ...keyboardInputFields,
      [inputName]: inputVal,
    });

    keyboard?.current?.setInput(inputVal);
  };
  const cart = JSON.parse(localStorage.getItem("cartObj"));
  useEffect(() => {
    setDisplayedProducts(filteredProducts.slice(0, ITEMS_PER_LOAD));
    setHasMoreProducts(filteredProducts.length > ITEMS_PER_LOAD);
  }, [filteredProducts]);

  const handleScrollLoad = (event) => {
    const scrollEl = event.target;
    const maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
    const currentScroll = scrollEl.scrollTop;

    if (Math.round(currentScroll) >= Math.round(maxScroll - 100) && hasMoreProducts) {
      const lengthOff = displayedProducts.length;
      if (lengthOff < filteredProducts.length) {
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
          const nextBatch = filteredProducts.slice(lengthOff, lengthOff + ITEMS_PER_LOAD);
          setDisplayedProducts((prev) => [...prev, ...nextBatch]);
          if (lengthOff + nextBatch.length >= filteredProducts.length) {
            setHasMoreProducts(false);
          }
        }, 200);
      }
    }
  };

  const clearCartData = {
    items: [],
    couponInput: [],
    advancePayment: 0,
    total: 0,
    tax: 0,
    discount: 0,
    paid: 0,
    change: 0,
    totalQty: 0,
    roundOff: 0,
    payments: [],
    redemptionPoints: 0,
    accumulationPoints: 0,
    creditAmount: 0,
    docType: "Invoice",
    sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
    referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
    giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    customer: defaultCustomer,
    salesRepId: null,
    cardPaymentData: {},
    // documentno: cart.documentno,
    documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
    userName: userData.user,
    tillName: tillValue?.name,
    subTotal: 0,
    itemsSummery: {},
    amountInWords: "",
    groupedItemsByTaxRate: {},
  };

  const getPriorityTag = (priority) => {
    if (priority === "HIGH") return <Tag color="red">HIGH</Tag>;
    if (priority === "MEDIUM") return <Tag color="gold">MEDIUM</Tag>;
    return <Tag color="green">LOW</Tag>;
  };

  useEffect(() => {
    const scrollEl = scrollContainerRef.current;
    if (scrollEl) {
      scrollEl.addEventListener("scroll", handleScrollLoad);
      return () => scrollEl.removeEventListener("scroll", handleScrollLoad);
    }
  }, [displayedProducts, filteredProducts]);

  // Start AHT timer when Call Center page is opened
  // AHT Timer with Hold (Pause/Resume)
  // AHT Timer: Reset & Start when call is active
  useEffect(() => {
    if (callCenterVisible) {
      setAhtSeconds(0); // Reset to 0
      timerRef.current = setInterval(() => {
        setAhtSeconds((prev) => prev + 1);
      }, 1000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [callCenterVisible]); // ← Restart when call resumes

  const formatAHT = (totalSeconds) => {
    const mins = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
    const secs = String(totalSeconds % 60).padStart(2, "0");
    return `${mins}:${secs}`;
  };

const fetchRetailStores = async () => {
  try {
    const stores = await getRetailStores();
    if (stores.length > 0) {
      setRetailStores(stores);
      const currentStoreValue = tillData?.tillAccess?.csBunit?.value;
      const defaultStore = stores.find(s => s.value === currentStoreValue) || stores[0];
      setSelectedStore(defaultStore);
      // Also save to cart
      setCart(prev => ({ ...prev, selectedStore: defaultStore }));
    } else {
      message.warning("No stores found");
    }
  } catch (err) {
    message.error("Failed to load stores");
  }
};

  useEffect(() => {
    const fetchProductsAndCategories = async () => {
      try {
        const products = await db.products.filter(product => product.isactive === true).toArray();

        if (products?.length > 0) {
          setProductsList(products); // Store all products
          setFilteredProducts(products); // Initially show all products

          // Fetch categories and filter based on available products
          const categories = await db.productCategories.toArray();
          const filteredCategories = categories.filter((cat) => products.some((p) => p.mProductCategoryId === cat.mProductCategoryId));
          const sortedCategories = [...filteredCategories].sort((a, b) => a.name.localeCompare(b.name));
          setProductCategoriesList(sortedCategories);

          // Set default category and filter products
          if (sortedCategories.length > 0) {
            const firstCategoryId = sortedCategories[0].mProductCategoryId;
            setSelectCategoryList([firstCategoryId]);
            setFilteredProducts(products.filter((product) => product.mProductCategoryId === firstCategoryId));
          }
        } else {
          console.warn("⚠️ No products found in IndexedDB.");
          message.warning("No products found in local database");
        }
      } catch (error) {
        console.error("❌ Error fetching data from IndexedDB:", error);
        message.error("Failed to load products or categories");
      }
    };

    fetchProductsAndCategories();
  }, []);

  const handleCategoryClick = (categoryId) => {
    setSelectCategoryList([categoryId]); // Single selection
    const filtered = productsList.filter((product) => product.mProductCategoryId === categoryId);
    setFilteredProducts(filtered); // Update filtered products
  };
  useEffect(() => {
    hasLoadedOrderHistory.current = false;
  }, [cart?.customer?.cwrCustomerId]);

  const loadOrderHistory = async () => {
    if (!callCenterVisible || hasLoadedOrderHistory.current) return;

    hasLoadedOrderHistory.current = true;
    setLoading(true);
    try {
      const today = [moment(new Date()), moment(new Date())];
      await searchOrderHistory("orderDateSearchKey", today, 0, false, true);
    } catch (err) {
      console.error(err);
      message.error("Failed to load order history");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    localStorage.setItem("callCenterHoldQueue", JSON.stringify(holdQueue));
  }, [holdQueue]);

useEffect(() => {
  if (callCenterVisible && cart?.customer?.cwrCustomerId) {
    hasLoadedOrderHistory.current = false;
    loadOrderHistory();
  }
}, [callCenterVisible, cart?.customer?.cwrCustomerId]);

useEffect(() => {
  hasLoadedOrderHistory.current = false;
}, [cart?.customer?.cwrCustomerId]);

 useEffect(() => {
   // Load stores **once** when the component first mounts
   if (callCenterVisible && !storesLoaded.current) {
     storesLoaded.current = true;
     fetchRetailStores();               // sets default store + populates retailStores
   }

   // Keep UI button in sync with whatever store is in the cart
   if (cart?.selectedStore) {
     setSelectedStore(cart.selectedStore);
   }
 }, [callCenterVisible, cart?.selectedStore]);

  // Resume a held call: restore cart, AHT, and open call screen
  const resumeHoldCall = (holdEntry) => {
    // Restore full cart
    setCart(holdEntry.cart);
   setSelectedStore(holdEntry.selectedStore);
    // Resume AHT timer from saved time
    setAhtSeconds(holdEntry.ahtSeconds);
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setAhtSeconds((prev) => prev + 1);
    }, 1000);

    // Remove from hold queue
    setHoldQueue((prev) => prev.filter((c) => c.id !== holdEntry.id));

    // Show call screen
    setCallCenterVisible(true);
  };
// Random pastel colors for product cards
const pastelColors = [
  "#F8C8DC", "#FFD1D1", "#FFE5B4", "#FFF4C1",
  "#D4F4DD", "#C8E6F5", "#D1E8FF", "#E6E6FA",
  "#F0D4F0", "#FFE4E1", "#E0F7FA", "#F5F5DC",
];

const getRandomPastel = () => pastelColors[Math.floor(Math.random() * pastelColors.length)];

const getColorFromId = (id) => {
  const hash = id.split('').reduce((a, b) => a + b.charCodeAt(0), 0);
  return pastelColors[hash % pastelColors.length];
};

const addPaymentLine = (payments = [], method, amount) => {
  const line = {
    name: method.name,
    amount: parseFloat(amount).toFixed(pricePrecision || 2),
  };
  return [...payments, line];
};

const handleCardPayment = async () => {
  try {
    const total = parseFloat(cart?.total || 0);
    if (total <= 0) {
      message.error("Cart is empty");
      return;
    }

    if (!selectedPaymentMethod) {
      message.error("Select a payment method");
      return;
    }

    // Build payment line
    const newLine = {
      name: selectedPaymentMethod.name,
      amount: total.toFixed(pricePrecision || 2),
    };

    const updatedCart = {
      ...cart,
      payments: [...(cart.payments || []), newLine],
      paid: total,
      change: 0,
    };

    setCart(updatedCart);
    localStorage.setItem("cartObj", JSON.stringify(updatedCart));

    // Special Card flow
    if (tillData?.tillAccess?.posConfig?.transactionID === "Y" && selectedPaymentMethod.name === "Card") {
      // Show card details modal (you already have this)
      // setShowCardModal(true);
      return;
    }

    // Final submit
    await posOrderProcessor1(updatedCart);
    message.success("Order placed!");

    // Reset
    setCart(clearCartData);
    setSelectedPaymentMethod(null);
    setCallCenterVisible(false);
    setIsPaymentSelected(false);
  } catch (err) {
    console.error(err);
    message.error("Failed to place order");
  }
};


const handlePlaceOrder = async () => {
  // ---- Validation ----
  if (!selectedPaymentMethod) {
    message.error("Please select a payment method");
    return;
  }
  const total = parseFloat(cart?.total || 0);
  if (total <= 0) {
    message.error("Cart is empty");
    return;
  }

  // ---- Build payment line (full amount) ----
  const paymentLine = {
    name: selectedPaymentMethod.name,
    amount: total.toFixed(pricePrecision || 2),
  };

  const updatedCart = {
    ...cart,
    payments: [...(cart.payments || []), paymentLine],
    paid: total,
    change: 0,
  };

  setCart(updatedCart);
  localStorage.setItem("cartObj", JSON.stringify(updatedCart));

  // ---- Card transactionID flow (if enabled) ----
  if (
    tillData?.tillAccess?.posConfig?.transactionID === "Y" &&
    selectedPaymentMethod.name === "Card"
  ) {
    message.info("Enter card details then submit");
    // setShowCardModal(true); // ← your modal
    return;
  }

  // ---- Reset guards & call real processOrder prop ----
  orderState.current = 0;
  try {
    await processOrder("normal");
  } catch (err) {
    console.error(err);
    message.error("Failed to place order");
  }
};

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} spin />} spinning={loading}>
    <div style={{ fontFamily: "Inter", maxHeight: "100vh", paddingBottom: "70px", backgroundColor: "white" }}>
      {/* 🔹 Top Header Bar (100% width) */}
      {callCenterVisible ? (
        <>
          <div
            style={{
              backgroundColor: "#fff",
              border: "1px solid #e0e0e0",
              padding: "10px 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
              marginBottom: "0",
              position: "relative",
            }}
          >
            {/* ----------- NEW: Back Icon (same behaviour as POS logo) ----------- */}
            <img
              src={BackIcon}
              alt="Back"
              style={{
                height: "24px",
                cursor: "pointer",
                position: "absolute",
                left: "12px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
              onClick={() => {
                // Same navigation pattern used for the POS logo
                history.push("/pos"); // <-- always go to POS home
              }}
            />

            {/* ------------------- ORIGINAL LEFT SECTION (shifted right) ------------------- */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap", marginLeft: "36px" }}>
              <Tag color="blue" style={{ borderRadius: "15px" }}>
                Caller
              </Tag>

              <span style={{ fontWeight: 600, color: "#0F0718" }}>
                <PhoneOutlined style={{ marginRight: 6 }} />
                {cart?.customer?.mobileNo ? `+91 ${cart.customer.mobileNo}` : "+91 –"}
              </span>

              <span style={{ fontWeight: 600, color: "#0F0718" }}>{cart?.customer?.name || "Guest"}</span>

              <span style={{ color: "#929098" }}>{cart?.customer?.customerAddress?.city || cart?.customer?.customerAddress?.region || "–"}</span>

              <Tag color="blue" style={{ borderRadius: "15px" }}>
                Status: Available
              </Tag>
            </div>

            {/* ------------------- ORIGINAL RIGHT SECTION ------------------- */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Tag color="blue" style={{ borderRadius: "20px" }}>
                AHT {formatAHT(ahtSeconds)}
              </Tag>
              <Button
                style={{ borderRadius: "10px", color: "#2f3856" }}
                onClick={() => {
                  // ----- PAUSE TIMER -----
                  if (timerRef.current) {
                    clearInterval(timerRef.current);
                    timerRef.current = null;
                  }

                  // ----- SAVE TO holdQueue -----
                  const customer = cart?.customer || {};
                  const entry = {
                    id: Date.now(),
                    name: customer.name || "Guest",
                    phone: customer.mobileNo ? `+91 ${customer.mobileNo}` : "+91 –",
                    city: customer.customerAddress?.city || "–",
                    aht: formatAHT(ahtSeconds),
                    ahtSeconds: ahtSeconds,
                    priority: "MEDIUM", // or your logic
                    timestamp: new Date().toLocaleString(),
                    cart: cart,
                    selectedStore: selectedStore,
                  };

                  setHoldQueue((prev) => [...prev, entry]);
                  message.success(`Call on hold: ${entry.name} – ${entry.aht}`);
                  setCart(clearCartData);
                  // ----- NAVIGATE TO CALL CENTER PAGE -----
                  setCallCenterVisible(false);
                  setOrderHistoryDetails([]);
                  setIsPaymentSelected(false);
                  // setShowCallCenterPage(true);
                }}
              >
                Hold
              </Button>
              <Button
                type="primary"
                danger
                style={{ borderRadius: "10px" }}
                onClick={() => {
                  setCallCenterVisible(false);
                  setCart(clearCartData);
                  setIsPaymentSelected(false);
                }}
              >
                End Call
              </Button>
            </div>
          </div>

          {/* 🔹 Content Area (below header) */}
          <div style={{ display: "flex", height: "calc(100vh - 60px)" }}>
            {/* LEFT PANEL - Customer Search (20%) */}
            <div
              style={{
                width: "20%",
                backgroundColor: "#fff",
                borderRight: "1px solid #e0e0e0",
                padding: "15px",
                overflowY: "auto",
                height: "100%",
              }}
            >
              {/* Search Customer */}
              <div style={{ marginBottom: "15px" }}>
                <p style={{ fontSize: "11px", fontWeight: 600, color: "#777", marginBottom: "6px" }}>SEARCH CUSTOMER</p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId ? (
                    <Input
                      className="productSearch-sm"
                      id="sm-customer-search"
                      style={{
                        borderRadius: "0.5vw",
                        height: "4.9vh",
                        borderColor: "#fff",
                      }}
                      placeholder="Enter customer number/name"
                      prefix={<img src={CustomerSearch} alt="" style={{ height: "2.7vh" }} />}
                      onClick={() => {
                        if (cart?.isReturn !== true) {
                          setDisplayCustomerSearch(true);
                          setCloseCustomerFlag(true);
                          setProductSearchInput("");
                        }
                      }}
                      onChange={(e) => {
                        if (navigator.onLine) {
                          onChangeInput(e);
                          if (e.target.value === "") {
                            setCustomerSearchResults();
                            setCustomerSearchInput(e.target.value);
                            setLoading(false); // Reset loading when input is cleared
                          } else {
                            setCustomerSearchInput(e.target.value);
                            setLoading(true); // Set loading to true when input changes
                            // Assuming handleCustomerSearch is an async function that fetches customers
                            handleCustomerSearch(e.target.value)
                              .then((results) => {
                                setCustomerSearchResults(results);
                                setLoading(false); // Reset loading when search completes
                              })
                              .catch(() => {
                                setLoading(false);
                              });
                          }
                        } else {
                          setLoading(false);
                        }
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        padding: "0.7vh 1.3vh",
                        border: "none",
                        background: "#fff",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        height: "5vh",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        <img src={CustomerIcon} style={{ height: "3.5vh" }} alt="" />{" "}
                        <span style={{ fontSize: "1vw" }}>
                          {cart?.customer?.name} - {cart?.customer?.b2cCustomerSegment?.name}
                        </span>
                      </span>
                      <span>
                        <img
                          src={View}
                          style={{
                            height: "3vh",
                            paddingBottom: "0.1em",
                            cursor: "pointer",
                          }}
                          id="sm-customer-view"
                          onClick={() => {
                            if (cart.isReturn !== true) showEditOldCustomerFields(cart?.customer);
                          }}
                        />{" "}
                        &#124;{" "}
                        <EditOutlined
                          style={{ cursor: "pointer" }}
                          id="sm-customer-edit"
                          onClick={() => {
                            if (cart.isReturn !== true) {
                              showEditOldCustomerFields(cart?.customer);
                              setEditFlag(true);
                            }
                          }}
                        />{" "}
                        &#124;{" "}
                        <CloseOutlined
                          style={{ fontSize: "2vh", cursor: "pointer" }}
                          onClick={() => {
                            if (cart.isReturn !== true) removeCutomer();
                          }}
                        />
                      </span>
                    </div>
                  )}

                  <img
                    src={AddUser}
                    style={{
                      height: "1.6vw",
                      paddingLeft: "1vw",
                      cursor: "pointer",
                      display: cart?.customer?.cwrCustomerId === customerId ? "" : "none",
                    }}
                    onClick={() => {
                      if (cart.isReturn !== true) {
                        showAddNewCustomerFields(cart.customer);
                        setProductSearchInput("");
                      }
                    }}
                  />
                </div>
              </div>

              {/* Customer Info */}
              {/* ---------- Customer Info (now dynamic) ---------- */}
              <div
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "10px",
                  padding: "10px 12px",
                  marginBottom: "15px",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  {/* Customer name – taken from cart (same as header) */}
                  <span style={{ fontWeight: 600, color: "#2F3856" }}>{cart?.customer?.name || "Guest"}</span>

                  {/* Loyalty points – you can replace 420 with a real value from cart if you have it */}
                  <Tag
                    color="gold"
                    style={{
                      borderRadius: "12px",
                      fontWeight: 600,
                      fontSize: "12px",
                      padding: "0 6px",
                    }}
                  >
                    <StarFilled style={{ color: "#f5a623", marginRight: 3 }} />
                    {cart?.customer?.loyaltyPoints ?? 420}
                  </Tag>
                </div>

                {/* Phone number – same format as header */}
                <p style={{ fontSize: "13px", color: "#333", marginTop: "4px" }}>{cart?.customer?.mobileNo ? `+91 ${cart.customer.mobileNo}` : "+91 –"}</p>
              </div>

              {/* ---------- Delivery Addresses (dynamic list) ---------- */}
              <div style={{ marginBottom: "15px" }}>
                <p style={{ fontSize: "11px", fontWeight: 600, color: "#777", marginBottom: "8px" }}>DELIVERY ADDRESSES</p>

                {/* Single address – same data & layout as Checkout */}
                <div
                  onClick={() => setSelectedAddress("Home")} // keep selection logic
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    padding: "2px 5px",
                    marginBottom: "8px",
                    backgroundColor: selectedAddress === "Home" ? "#f0f6ff" : "#fff",
                    cursor: "pointer",
                  }}
                >
                  <p
                    style={{
                      fontSize: "11px",
                      fontWeight: 500,
                      color: "#929098",
                      marginBottom: 4,
                    }}
                  >
                    Home
                  </p>

                  <p
                    style={{
                      fontSize: "11px",
                      fontWeight: 500,
                      marginBottom: 1,
                      color: "#0F0718",
                    }}
                  >
                    {cart?.customer?.customerAddress?.city || cart?.customer?.customerAddress?.region || "–"}
                  </p>

                  <p style={{ fontSize: "11px", color: "#0F0718", marginBottom: 1 }}>
                    {cart?.customer?.customerAddress?.line1
                      ? `${cart.customer.customerAddress.line1}${cart.customer.customerAddress.line2 ? `, ${cart.customer.customerAddress.line2}` : ""}`.trim()
                      : ""}
                  </p>

                  {cart?.customer?.pincode && <p style={{ fontSize: "10px", color: "#929098", marginBottom: 1 }}>Pin: {cart.customer.pincode}</p>}
                </div>
              </div>

              {/* ---------- ORDER HISTORY (auto-loaded cards) ---------- */}
              <div style={{ marginTop: "15px" }}>
                <p style={{ fontSize: "11px", fontWeight: 600, color: "#777", marginBottom: "5px" }}>ORDER HISTORY</p>

                {/* REMOVED: {callCenterVisible && loadOrderHistory()} */}

                {loading ? (
                  <Skeleton active paragraph={{ rows: 2 }} />
                ) : !orderHistoryDetails || orderHistoryDetails.length === 0 ? (
                  <p style={{ textAlign: "center", color: "#999", margin: "12px 0" }}>No previous orders</p>
                ) : (
<Scrollbars style={{ height: "220px" }}> {/* ✅ increased scroll height */}
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      paddingRight: "4px",
    }}
  >
    {orderHistoryDetails.map((order) => (
      <div
        key={order.sOrderID}
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "10px",
          padding: "10px 12px",
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: "4px",
          }}
        >
          <div>
            <div style={{ fontWeight: 600, fontSize: "13px", color: "#0F0718" }}>
              {order.documentno}
            </div>
            <div style={{ fontSize: "11px", color: "#666" }}>
              {moment(order.dateordered).format("YYYY-MM-DD")}
            </div>
          </div>
          <Tag
            color="#dcfce7"
            style={{
              color: "#166534",
              borderRadius: "12px",
              fontSize: "10px",
              fontWeight: 500,
              padding: "0 6px",
              border: "none",
            }}
          >
            Delivered
          </Tag>
        </div>
        <div style={{ fontWeight: 600, fontSize: "13px", color: "#0F0718" }}>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          {order.total}
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </div>
      </div>
    ))}
  </div>
</Scrollbars>
                )}
              </div>
            </div>

            {/* RIGHT EMPTY AREA (80%) */}
            <div
              style={{
                width: "57%",
                backgroundColor: "#fff",
                borderRight: "1px solid #e0e0e0",
                padding: "10px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                fontWeight: "500",
              }}
            >
              {/* Search Bar */}
              <div style={{ marginBottom: "10px" }}>
                <Input
                  placeholder="Search for products by code/name"
                  value={productSearchInput}
                  onChange={(e) => {
                    const searchTerm = e.target.value.toLowerCase();
                    setProductSearchInput(searchTerm);
                    if (searchTerm === "") {
                      const sortedCategories = [...productCategoriesList].sort((a, b) => a.name.localeCompare(b.name));
                      if (sortedCategories.length > 0) {
                        const firstCategoryId = sortedCategories[0].mProductCategoryId;
                        setSelectCategoryList([firstCategoryId]);
                        setFilteredProducts(productsList.filter((product) => product.mProductCategoryId === firstCategoryId));
                      } else {
                        setFilteredProducts(productsList);
                        setSelectCategoryList([]);
                      }
                    } else {
                      const matchingProducts = productsList.filter((p) => p.name.toLowerCase().includes(searchTerm));
                      setFilteredProducts(matchingProducts);
                      if (matchingProducts.length > 0) {
                        setSelectCategoryList([matchingProducts[0].mProductCategoryId]);
                      } else {
                        setSelectCategoryList([]);
                      }
                    }
                  }}
                  style={{
                    color: "#929098",
                    borderRadius: "8px",
                    height: "30px",
                    width: "100%",
                  }}
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="Search"
                      style={{
                        width: 16,
                        height: 16,
                        opacity: 0.6,
                        marginRight: 0,
                      }}
                    />
                  }
                  suffix={
                    productSearchInput?.length > 0 ? (
                      <CloseSquareFilled
                        onClick={() => {
                          setProductSearchInput("");
                          const sortedCategories = [...productCategoriesList].sort((a, b) => a.name.localeCompare(b.name));
                          if (sortedCategories.length > 0) {
                            const firstCategoryId = sortedCategories[0].mProductCategoryId;
                            setSelectCategoryList([firstCategoryId]);
                            setFilteredProducts(productsList.filter((product) => product.mProductCategoryId === firstCategoryId));
                          } else {
                            setFilteredProducts(productsList);
                            setSelectCategoryList([]);
                          }
                        }}
                        style={{ color: "#999", cursor: "pointer", fontSize: 18 }}
                      />
                    ) : null
                  }
                  onPressEnter={() => {
                    const searchTerm = productSearchInput.toLowerCase();
                    const matchingProducts = productsList.filter((p) => p.name.toLowerCase().includes(searchTerm));
                    setFilteredProducts(matchingProducts);
                    if (matchingProducts.length > 0) {
                      setSelectCategoryList([matchingProducts[0].mProductCategoryId]);
                    }
                  }}
                />
              </div>

              {/* Categories */}
              <div
                style={{
                  display: "flex",
                  overflowX: "auto",
                  color: "#0F0718",
                  fontWeight: "500",
                  gap: "8px",
                  paddingBottom: "10px",
                  marginBottom: "10px",
                }}
              >
                {productCategoriesList
                  .slice()
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((cat) => (
                    <button
                      key={cat.mProductCategoryId}
                      onClick={() => handleCategoryClick(cat.mProductCategoryId)}
                      style={{
                        backgroundColor: selectCategoryList.includes(cat.mProductCategoryId) ? "#eff6ff" : "#fff",
                        color: selectCategoryList.includes(cat.mProductCategoryId) ? "#2563eb" : "#0F0718",
                        fontWeight: 500,
                        border: "1px solid #e0e0e0",
                        borderRadius: "14px",
                        padding: "6px 12px",
                        fontSize: "13px",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {cat.name}
                    </button>
                  ))}
              </div>

              {/* Scrollable Product Grid */}
              <div style={{ flex: 1, overflowY: "auto", paddingRight: "4px", position: "relative" }} ref={scrollContainerRef}>
                {displayedProducts.length === 0 ? (
                  <p style={{ textAlign: "center", color: "#999", marginTop: "20px" }}>No products found</p>
                ) : (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
                      gap: "12px",
                    }}
                  >
                    {displayedProducts.map((product) => (
<Card
  key={product.mProductId}
  style={{
    borderRadius: "10px",
    border: "1px solid #e8e8e8",
    padding: "10px",
    cursor: "pointer",
    color: "#0F0718",
    fontWeight: "500",
    backgroundColor: getColorFromId(product.mProductId),
    overflow: "hidden",
    height: showImage ? "130px" : "90px",
    display: "flex",
    flexDirection: "column",
    justifyContent: showImage ? "flex-start" : "center",
    position: "relative",
  }}
  onClick={() => pickProduct(product)}
>
  {showImage && (
    <div
      style={{
        height: "60px",
        marginBottom: "6px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={product.imageurl || DefaultProductImage}
        alt={product.name}
        style={{
          maxHeight: "100%",
          maxWidth: "100%",
          objectFit: "contain",
        }}
        onError={(e) => (e.currentTarget.src = DefaultProductImage)}
      />
    </div>
  )}
  {/* Product Name – centered, clipped, tooltip on hover */}
  <p
    title={product.name} // ✅ shows full name on hover
    style={{
      fontWeight: 500,
      fontSize: "13px",
      margin: 0,
      lineHeight: "1.4",
      textAlign: "center",
      whiteSpace: "nowrap", // ✅ single line
      overflow: "hidden", // ✅ clip overflow
      textOverflow: "ellipsis", // ✅ show "..."
      maxWidth: "100%", // ✅ ensures clipping works correctly
      padding: "0 4px", // small breathing space for text
    }}
  >
    {product.name}
  </p>

  {/* Price – bottom-right corner */}
  <p
    style={{
      color: "green",
      fontWeight: 500,
      fontSize: "12px",
      margin: "4px",
      position: "absolute",
      bottom: "8px",
      right: "10px",
    }}
  >
    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
    {product.sunitprice.toFixed(2)}
    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
  </p>
</Card>
                    ))}
                  </div>
                )}
                {hasMoreProducts && (
                  <div style={{ textAlign: "center", padding: "16px" }}>
                    <Skeleton active paragraph={{ rows: 2 }} />
                  </div>
                )}
              </div>
            </div>

{/* RIGHT PANEL – Checkout (23%) */}
<div
  style={{
    width: "23%",
    backgroundColor: "#fff",
    padding: "10px",
    overflow: "hidden",
    height: "100%",
    borderLeft: "1px solid #e0e0e0",
    display: "flex",
    flexDirection: "column",
  }}
>
  {/* ==== FIXED HEADER ==== */}
<div style={{ 
  display: "flex", 
  justifyContent: "flex-start", 
  alignItems: "center", 
  gap: "8px", 
  marginBottom: "5px" 
}}>
  <h3 style={{ margin: 0, color: "#0F0718" }}>Checkout</h3>
  <Button
    type="text"
    size="small"
    style={{
      fontSize: "12px",
      color: "#0F0718",
      fontWeight: 500,
      border: "1px solid #d9d9d9",
      borderRadius: "6px",
      padding: "2px 8px",
      display: "flex",
      alignItems: "center",
      gap: 6,
      maxWidth: "140px",
      overflow: "hidden",
      margin: 0,
    }}
    onClick={() => setStoreModalVisible(true)}
  >
    <span
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block",
      }}
      title={selectedStore?.name || "Select Store"}
    >
      Store: {selectedStore?.name || "Select"}
    </span>
  </Button>
</div>

  {/* ---- Delivery Mode Buttons ---- */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "14px",
      backgroundColor: "#fff",
      borderRadius: "20px",
      padding: "3px",
    }}
  >
    {modes.map((mode) => {
      const isActive = selectedMode === mode;
      return (
        <Button
          key={mode}
          size="small"
          onClick={() => setSelectedMode(mode)}
          style={{
            flex: 1,
            margin: "0 2px",
            borderRadius: "20px",
            backgroundColor: isActive ? "#3c4866" : "#F5F5F5",
            color: isActive ? "#fff" : "#333",
            border: "none",
            fontWeight: 500,
          }}
        >
          {mode}
        </Button>
      );
    })}
  </div>

  {/* ==== SCROLLABLE MIDDLE: Address, ETA, Cart Items ==== */}
  <div style={{ flex: 1, overflowY: "auto", paddingRight: "4px" }}>
    {/* ---- Serving Location ---- */}
    <div
      style={{
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        padding: "2px 5px",
        marginBottom: "10px",
      }}
    >
      <p style={{ fontSize: "11px", fontWeight: 500, color: "#929098", marginBottom: 4 }}>
        SERVING LOCATION
      </p>
      <p style={{ fontSize: "11px", fontWeight: 500, marginBottom: 1, color: "#0F0718" }}>
        {cart?.customer?.customerAddress?.city || cart?.customer?.customerAddress?.region || "–"}
      </p>
      <p style={{ fontSize: "11px", color: "#0F0718", marginBottom: 1 }}>
        {cart?.customer?.customerAddress?.line1
          ? `${cart.customer.customerAddress.line1}${
              cart.customer.customerAddress.line2 ? `, ${cart.customer.customerAddress.line2}` : ""
            }`.trim()
          : ""}
      </p>
      {cart?.customer?.pincode && (
        <p style={{ fontSize: "10px", color: "#929098", marginBottom: 1 }}>
          Pin: {cart.customer.pincode}
        </p>
      )}
    </div>

    {/* ---- ETA ---- */}
    {/* <div style={{ marginBottom: "4px" }}>
      <p style={{ fontSize: "12px", color: "#929098", marginBottom: 2 }}>
        ETA: 28–34 min · Distance: 2.3 km
      </p>
    </div> */}

    {/* ---- Promise Time ---- */}
    <div
      style={{
        border: "1px solid #92909880",
        color: "#929098",
        borderRadius: "8px",
        padding: "4px",
        marginBottom: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <span style={{ fontSize: "12px", color: "#555" }}>Promise Time</span>
      <Select
        size="small"
        defaultValue="30"
        style={{ width: 70 }}
        options={[
          { value: "15", label: "15" },
          { value: "20", label: "20" },
          { value: "30", label: "30" },
          { value: "45", label: "45" },
        ]}
      />
    </div>

    {/* ---- CART ITEMS (own scroll) ---- */}
    <div
      style={{
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        padding: "10px",
        maxHeight: "180px",  // Reduced to fit more in scroll area
        overflowY: "auto",
        marginBottom: "12px",
      }}
    >
      <p style={{ fontWeight: 500, fontSize: "13px", marginBottom: "8px", color: "#0F0718" }}>
        Cart Items ({cart?.items?.length || 0})
      </p>

      {cart?.items?.length > 0 ? (
        cart.items.map((item, idx) => (
          <div
            key={item.mProductId || idx}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid #f0f0f0",
              padding: "8px 0",
            }}
          >
            <div>
              <p style={{ fontWeight: 600, fontSize: "11px", color: "#0F0718", margin: 0, fontWeight: "500" }}>
                {item.name}
              </p>
              <p style={{ fontSize: "10px", color: "#929098", margin: 0, fontWeight: "500" }}>
                {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                {item.nettotal.toFixed(2)}
                {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
              </p>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <Button size="small" shape="circle" onClick={() => decreaseProductQty(item)}>
                -
              </Button>
              <span style={{ fontWeight: 500, color: "#0F0718", fontSize: "11px" }}>
                {item.weight || 1}
              </span>
              <Button size="small" shape="circle" onClick={() => increaseProductQty(item)}>
                +
              </Button>
            </div>
          </div>
        ))
      ) : (
        <p style={{ textAlign: "center", color: "#999", marginTop: "20px" }}>
          No items in cart
        </p>
      )}
    </div>
  </div>

  {/* ==== FIXED FOOTER: Coupon → Buttons (Always Visible) ==== */}
  <div style={{ borderTop: "1px solid #e0e0e0", paddingTop: "10px" }}>
    {/* ---- Coupon Code ---- */}
    <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "12px" }}>
      <Input
        placeholder="Enter coupon code"
        size="middle"
        style={{
          flex: 1,
          borderRadius: "7px",
          height: "30px",
        }}
      />
      <Button
        type="primary"
        style={{
          backgroundColor: "#7dcf7d",
          border: "none",
          borderRadius: "7px",
          height: "30px",
        }}
      >
        Best
      </Button>
    </div>

    {/* ---- Price Details ---- */}
{/* ---- Price Details (Collapsible) ---- */}
<div style={{ fontSize: "11px", fontWeight: "500", marginBottom: "5px", color: "#0F0718" }}>
  {/* Header row: View Details + toggle arrow */}
  <div
    onClick={() => setShowPriceDetails((prev) => !prev)} // ✅ toggle visibility
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      marginBottom: "6px",
      backgroundColor: "#f3f4f9",
      padding: "6px 10px",
      borderRadius: "6px",
    }}
  >
    <span style={{ fontWeight: 600, fontSize: "12px" }}>View Details</span>
    <span
      style={{
        transform: showPriceDetails ? "rotate(90deg)" : "rotate(0deg)",
        transition: "transform 0.2s ease",
        fontSize: "14px",
      }}
    >
      ▶
    </span>
  </div>

  {/* Collapsible section */}
  {showPriceDetails && (
    <div style={{ animation: "fadeIn 0.2s ease" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>Items</span>
        <span>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          {(cart?.subTotal ?? 0).toFixed(2)}
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>Packing</span>
        <span>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          {(cart?.packingCharge ?? 0).toFixed(2)}
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>Delivery</span>
        <span>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          {(cart?.deiveryCharge ?? 0).toFixed(2)}
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>Tax</span>
        <span>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          {(cart?.tax ?? 0).toFixed(2)}
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", color: "green" }}>
        <span>Discount</span>
        <span>
          {currenciesList[0].symbolRightSide === "Y" ? `-${currenciesList[0].currSymbol} ` : "-"}
          {(cart?.discount ?? 0).toFixed(2)}
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </span>
      </div>

      <hr style={{ margin: "8px 0" }} />
    </div>
  )}

  {/* Always visible total */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      fontWeight: 600,
      marginTop: showPriceDetails ? "0" : "8px",
    }}
  >
    <span>Total Payable</span>
    <span>
      {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
      {(cart?.total ?? 0).toFixed(2)}
      {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
    </span>
  </div>
</div>


{/* Payment Methods Section */}
<div style={{ marginBottom: "10px", fontWeight: "500" }}>
  <p style={{ fontSize: "12px", fontWeight: 500, color: "#929098", marginBottom: 6 }}>
    PAYMENT METHOD
  </p>

  {/* Compute fresh every time */}
  {(() => {
    const allFiltered = getFilteredPaymentMethods();
    const displayed = allFiltered.length > 5 ? allFiltered.slice(0, 5) : allFiltered;

    return displayed.length > 0 ? (
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px" }}>
        {displayed.map((pm) => (
          <Button
            key={pm.name}
            size="small"
            type={selectedPaymentMethod?.name === pm.name ? "primary" : "default"}
            onClick={() => {
              setSelectedPaymentMethod(pm);
              setIsPaymentSelected(true);
            }}
            style={{
              borderRadius: "7px",
              fontSize: "12px",
              backgroundColor: selectedPaymentMethod?.name === pm.name ? "#2F3856" : "#fff",
              color: selectedPaymentMethod?.name === pm.name ? "#fff" : "#0F0718",
              borderColor: "#e8e8e8",
            }}
          >
            {pm.name}
          </Button>
        ))}
      </div>
    ) : (
      <div style={{ textAlign: "center", color: "#999", padding: "8px" }}>
        <Spin size="small" /> Loading...
      </div>
    );
  })()}
</div>

    {/* ---- Action Buttons ---- */}
    <div style={{ display: "flex", justifyContent: "space-between", gap: "6px" }}>
      <Button
        style={{ flex: 1, borderRadius: "7px", color: "#2f3856" }}
        onClick={() => {
          if (timerRef.current) clearInterval(timerRef.current);
          const entry = {
            id: Date.now(),
            name: cart?.customer?.name || "Guest",
            phone: cart?.customer?.mobileNo ? `+91 ${cart.customer.mobileNo}` : "+91 –",
            city: cart?.customer?.customerAddress?.city || "–",
            aht: formatAHT(ahtSeconds),
            ahtSeconds,
            priority: "MEDIUM",
            timestamp: new Date().toLocaleString(),
            cart,
            selectedStore: selectedStore,
          };
          setHoldQueue((prev) => [...prev, entry]);
          message.success(`Call parked: ${entry.name} – ${entry.aht}`);
          setCart(clearCartData);
          setCallCenterVisible(false);
        }}
      >
        Park
      </Button>
      <Button style={{ flex: 1, borderRadius: "7px", color: "#2f3856" }}>Reorder</Button>
<Button
  type="primary"
  disabled={!isPaymentSelected}
  style={{
    flex: 1,
    backgroundColor: isPaymentSelected ? "#2F3856" : "#e0e0e0",
    borderColor: isPaymentSelected ? "#2F3856" : "#e0e0e0",
    borderRadius: "7px",
    position: "relative",
    overflow: "hidden",
  }}
  onClick={handlePlaceOrder}
  onMouseEnter={(e) => {
    if (!isPaymentSelected) {
      const btn = e.currentTarget;
      btn.style.backgroundColor = "#ff4d4f";
      btn.style.borderColor = "#ff4d4f";
      btn.style.color = "#fff";

      btn.querySelector("#place-btn-x")?.remove();
      const x = document.createElement("span");
      x.textContent = "X";
      x.id = "place-btn-x";
      x.style.position = "absolute";
      x.style.right = "8px";
      x.style.top = "50%";
      x.style.transform = "translateY(-50%)";
      x.style.fontWeight = "bold";
      x.style.fontSize = "14px";
      btn.appendChild(x);

      message.error("Please select a payment method");
    }
  }}
  onMouseLeave={(e) => {
    if (!isPaymentSelected) {
      const btn = e.currentTarget;
      btn.style.backgroundColor = "#e0e0e0";
      btn.style.borderColor = "#e0e0e0";
      btn.style.color = "#000";
      btn.querySelector("#place-btn-x")?.remove();
    }
  }}
>
  Place
</Button>
    </div>
  </div>
</div>
          </div>
        </>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            background: "#f3f4f9",
            fontFamily: "Inter",
          }}
        >
          {/* ---- Header ---- */}
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "6px 12px",
              margin: "12px 12px 0",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              border: "1px solid #f4f3f4",
            }}
          >
            {/* LEFT: Back Icon + POS Logo */}
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <img
                src={BackIcon}
                alt="Back"
                style={{ height: "24px", cursor: "pointer" }}
                onClick={() => {
                  setShowCallCenterPage(false);
                  history.push("/pos");
                }}
              />
              <img src={POSLogo} alt="POS Logo" style={{ height: "32px", cursor: "pointer" }} onClick={() => history.push("/pos")} />
              <span
                style={{
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: "1.5em",
                  color: "#0F0718",
                  marginLeft: "0.2vw",
                  borderRadius: "2px",
                  marginTop: "0.45rem",
                }}
              >
                Call Center
              </span>
            </div>

            {/* RIGHT: Clock + Lock + User + Till + Online */}
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: "12px", color: "#929098" }}>
                {new Date().toLocaleTimeString()} |{" "}
                {new Date().toLocaleDateString("en-US", {
                  weekday: "long",
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </span>
              <Col>
                <img src={LockIcon} style={{ height: "20px", cursor: "pointer" }} alt="Lock" />
              </Col>
              <Col>
                <div
                  style={{
                    border: "1px solid #4b5563",
                    borderRadius: "50%",
                    padding: "4px",
                  }}
                >
                  <img src={userIcon} style={{ height: "20px" }} alt="User" />
                </div>
              </Col>
              <Col>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span style={{ fontSize: "12px", fontWeight: 500 }}>{JSON.parse(localStorage.getItem("userData")).user}</span>
                  <span style={{ fontSize: "10px", color: "#6b7280" }}>Till ID: {tillValue?.name}</span>
                </div>
              </Col>
              <div style={{ color: "#d00", fontWeight: 600, marginLeft: "10px" }}>{holdQueue?.length} Waiting</div>
            </div>
          </div>

          {/* ---- Calls on Hold Summary ---- */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 12,
              padding: "16px 20px 8px",
              maxHeight: "35vh", // ✅ scrollable area height = 40% of viewport
              overflowY: "auto", // ✅ vertical scroll
            }}
          >
{holdQueue.map((c) => (
  <Card
    key={c.id}
    size="small"
    style={{
      width: 200,
      height: 120, // ✅ fixed height
      borderRadius: 8,
      background: "#fff",
      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
      border: "1px solid #e9e8ea",
      position: "relative",
      flex: "0 0 auto",
      padding: "8px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    }}
  >
    {/* Name + AHT in same row */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 4,
      }}
    >
      <div
        title={c.name} // ✅ show full name on hover
        style={{
          fontWeight: 600,
          fontSize: 14,
          color: "#0F0718",
          maxWidth: 100, // ✅ clip width
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {c.name}
      </div>
      <div style={{ fontSize: 12, color: "#d00", flexShrink: 0 }}>
        <ClockCircleOutlined /> {c.aht}
      </div>
    </div>

    {/* Phone */}
    <div style={{ fontSize: 12, color: "#929098", marginBottom: 8 }}>
      {c.phone}
    </div>

    {/* Status + Retrieve */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff9e6",
          border: "1px solid #ffe58f",
          color: "#b38b00",
          fontSize: 11,
          fontWeight: 600,
          padding: "2px 8px",
          borderRadius: "7px",
        }}
      >
        On Hold
      </div>
<Button
  type="default"
  size="small"
  style={{
    fontSize: 11,
    height: 24,
    padding: "0 8px",
    backgroundColor: "#e6f9e6", // ✅ light green background
    border: "1px solid #28a745", // ✅ green border
    color: "#0F0718",
    fontWeight: 500,
    borderRadius:"7px"
  }}
  onClick={(e) => {
    e.stopPropagation();
    resumeHoldCall(c);
  }}
>
  Retrieve
</Button>

    </div>
  </Card>
))}

          </div>

          {/* ---- Search + Sort ---- */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "8px 20px",
            }}
          >
            <Input
              placeholder="Search for customer by phone, name..."
              prefix={<SearchOutlined style={{ color: "#929098" }} />}
              style={{
                width: "60%", // reduced width
                height: 32,
                fontSize: 13,
                borderRadius: 6,
                border: "1px solid #92909880",
                marginTop: "2vw",
              }}
              allowClear
              onFocus={() => {
                setDisplayCustomerSearch(true);
                setShowProducts(false);
                setIsCallCenterFlow(true);
              }}
            />
          </div>
        </div>
      )}
{/* Store Selection Drawer */}
<Drawer
  title={<span style={{ fontSize: "20px", color: "#0F0718", fontWeight: 600 }}>Select Store</span>}
  placement="right"
  width={380}
  onClose={() => setStoreModalVisible(false)}
  visible={storeModalVisible} // ✅ use `open` instead of `visible` in latest AntD
  headerStyle={{ background: "white", borderBottom: "none", padding: 0 }}
  bodyStyle={{ padding: "0.5rem", paddingTop: 0, background: "white" }}
  closeIcon={<span style={{ color: "#0F0718", fontSize: "20px" }}>×</span>} // ✅ close icon color
>
  <div style={{ padding: "12px" }}>
    {/* ---- Search ---- */}
    <Input
      placeholder="Search store"
      prefix={<SearchOutlined style={{ color: "#929098" }} />}
      style={{ marginBottom: 12 }}
      allowClear
      onChange={(e) => {
        const term = e.target.value.toLowerCase();
        setRetailStores((prev) =>
          prev.filter(
            (s) =>
              s.name.toLowerCase().includes(term) ||
              s.value.toLowerCase().includes(term) ||
              (s.address && s.address.toLowerCase().includes(term))
          )
        );
      }}
    />

    {/* ---- Store Cards ---- */}
    <div
      style={{
        display: "grid",
        gap: "12px",
        gridTemplateColumns: "1fr",
        maxHeight: "calc(100vh - 150px)",
        overflowY: "auto",
      }}
    >
      {retailStores.map((store) => (
        <Card
          key={store.value}
          hoverable
          style={{
            cursor: "pointer",
            borderRadius: 8,
            background:
              selectedStore?.value === store.value ? "#eff6ff" : "#fff",
          }}
          onClick={() => {
            setSelectedStore(store);
            setCart((prev) => ({ ...prev, selectedStore: store }));
            setStoreModalVisible(false);
            message.success(`Store changed to: ${store.name}`);
          }}
        >
          <div style={{ fontWeight: 600, fontSize: 15 }}>{store.name}</div>
          <div style={{ fontSize: 12, color: "#929098" }}>
            {store.address || store.value}
          </div>
        </Card>
      ))}
    </div>
  </div>
</Drawer>
    </div>
    </Spin>
  );
};

export default RestaurantCallCenter;
